import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"
import { toaster } from "components/common/Toast"

const requestedFetchAssignedEquipments = createAction("equipmentAssignments/fetch/requested")
const receivedFetchAssignedEquipments = createAction("equipmentAssignments/fetch/received")
const failedFetchAssignedEquipments = createAction("equipmentAssignments/fetch/failed")

const requestedAssignEquipment = createAction("equipmentAssignments/assign/requested")
const receivedAssignEquipment = createAction("equipmentAssignments/assign/received")
const failedAssignEquipment = createAction("equipmentAssignments/assign/failed")

const requestedUnassignEquipment = createAction("equipmentAssignments/unassign/requested")
const receivedUnassignEquipment = createAction("equipmentAssignments/unassign/received")
const failedUnassignEquipment = createAction("equipmentAssignments/unassign/failed")

const initialState = {
  fetchOperation: {
    ...LOADING_INITIAL_STATE
  },
  assignOperation: {
    ...LOADING_INITIAL_STATE
  },
  unassignOperation: {
    ...LOADING_INITIAL_STATE
  }
}

const equipmentAssignmentsReducer = createReducer(initialState, {
  [requestedFetchAssignedEquipments.type]: (state) => {
    setRequested(state.fetchOperation)
  },
  [receivedFetchAssignedEquipments.type]: (state) => {
    setReceived(state.fetchOperation)
  },
  [failedFetchAssignedEquipments.type]: (state) => {
    setFailed(state.fetchOperation)
  },

  [requestedAssignEquipment.type]: (state) => {
    setRequested(state.assignOperation)
  },
  [receivedAssignEquipment.type]: (state, { payload }) => {
    setReceived(state.assignOperation)
    toaster.success({
      text: payload.message || "Equipment assigned successfully"
    })
  },
  [failedAssignEquipment.type]: (state, { payload }) => {
    setFailed(state.assignOperation)
    const errorMessage = payload?.data?.message || payload?.data?.errors?.[0] || "Failed to assign equipment"
    toaster.error({
      title: "Error",
      text: errorMessage
    })
  },

  [requestedUnassignEquipment.type]: (state) => {
    setRequested(state.unassignOperation)
  },
  [receivedUnassignEquipment.type]: (state, { payload }) => {
    setReceived(state.unassignOperation)
    toaster.success({
      title: "Success",
      text: payload.message || "Equipment removed from booking"
    })
  },
  [failedUnassignEquipment.type]: (state, { payload }) => {
    setFailed(state.unassignOperation)
    const errorMessage = payload?.data?.message || payload?.data?.errors?.[0] || "Failed to unassign equipment"
    toaster.error({
      title: "Error",
      text: errorMessage
    })
  }
})

export default equipmentAssignmentsReducer

export const assignEquipmentToBooking = (bookingId, equipmentId) =>
  api({
    url: `/guide/bookings/${bookingId}/assign_equipment`,
    method: "post",
    data: { equipment_id: equipmentId },
    onStart: requestedAssignEquipment.type,
    onSuccess: receivedAssignEquipment.type,
    onError: failedAssignEquipment.type
  })

export const unassignEquipmentFromBooking = (bookingId, equipmentId) =>
  api({
    url: `/guide/bookings/${bookingId}/unassign_equipment`,
    method: "delete",
    data: { equipment_id: equipmentId },
    onStart: requestedUnassignEquipment.type,
    onSuccess: receivedUnassignEquipment.type,
    onError: failedUnassignEquipment.type
  })

export const fetchAssignedEquipments = (bookingId) =>
  api({
    url: `/guide/bookings/${bookingId}/assigned_equipments`,
    method: "get",
    onStart: requestedFetchAssignedEquipments.type,
    onSuccess: receivedFetchAssignedEquipments.type,
    onError: failedFetchAssignedEquipments.type
  })

export const selectFetchAssignedEquipmentsLoading = (state) => state.equipmentAssignments.fetchOperation.loading
export const selectAssignEquipmentLoading = (state) => state.equipmentAssignments.assignOperation.loading
export const selectUnassignEquipmentLoading = (state) => state.equipmentAssignments.unassignOperation.loading
